import firebase from "store/firebase";
import "firebase/firestore";
import { Dispatch, AnyAction } from "redux";
import type { RootState } from "store/reducer";
import { resultsFromDoc } from "./utils";
import { subscribe } from "./listen-change";
import { loadIdResource } from "store/util/id-resource";
import {
  RESULTS_ACTION_TYPES,
  Result,
  resultsActions,
} from "./reducer";

export const ACTION_EVENT_RESULTS_ITEM_LOADING =
  RESULTS_ACTION_TYPES.startedLoading;
export const ACTION_EVENT_RESULTS_LOAD_ITEM = RESULTS_ACTION_TYPES.loaded;
export const ACTION_EVENT_RESULTS_LOAD_ITEM_ERROR =
  RESULTS_ACTION_TYPES.errored;

export default function loadItem(id: string) {
  return async (
    dispatch: Dispatch<AnyAction>,
    getState: () => RootState
  ) => {
    return loadIdResource<Result, RootState>(
      id,
      async (assertActive) => {
        const itemRef = firebase
          .firestore()
          .collection("results")
          .doc(id);
        const doc = await itemRef.get();
        if (!doc.exists) {
          // No results doc yet; commit a placeholder so the screen knows we
          // checked but found nothing.
          doc.data = () => ({});
        }
        const item = resultsFromDoc(doc);
        assertActive();
        // Subscribe via the per-id registry so the listener for event A is
        // not killed when the user navigates to event B.
        subscribe(id);
        return item;
      },
      {
        actions: resultsActions,
        selectSlice: (root) => root.results,
      }
    )(dispatch as any, getState);
  };
}
